import { render, staticRenderFns } from "./beranda.vue?vue&type=template&id=90427f6c&"
import script from "./beranda.vue?vue&type=script&lang=js&"
export * from "./beranda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports